import { useAdminsManager } from './admins-manager-module';

export const useAdmins = () => {
  const manager = useAdminsManager();

  return {
    manager,
  };
};
